
import Vue, { PropType } from 'vue';
import { OnlinePortalApplicationDocumentRequest } from '../../models';
import DocumentUpload from './document-upload.vue';
import BorrowerNotUploadingReasonModal from './borrower-not-uploading-reason-modal/borrower-not-uploading-reason-modal.vue';
import EsignForm from './esign-form.vue';
import MarkOnFileModal from './mark-on-file-modal/mark-on-file-modal.vue';
import { LoanApplication, FeatureFlagging, Document } from '@sageworks/jpi';

export default Vue.extend({
	name: 'DocumentUploadRow',
	components: {
		DocumentUpload,
		EsignForm,
		BorrowerNotUploadingReasonModal,
		MarkOnFileModal
	},
	props: {
		documentRequest: Object as PropType<OnlinePortalApplicationDocumentRequest>,
		showAdditionalButtons: Boolean,
	},
	computed: {
		potentialMatchCount(): number {
			return this.documentRequest.possibleDocuments?.length ?? 0;
		},
		loanApplication(): LoanApplication | null {
			return this.directStore.state.LoanApplicationData.loanApplication;
		},
		isLender(): boolean {
			return this.directStore.getters.User.isLender;
		},
		isEsignForm(): boolean {
			return (
				!!this.esignTemplateStatus &&
				this.esignTemplateStatus !== 'NOT_A_VALID_ADOBE_TEMPLATE' &&
				this.esignTemplateStatus !== 'NOT_A_VALID_DOCUSIGN_TEMPLATE'
			);
		},
		esignTemplateStatus(): string | undefined {
			const statusMap = this.directStore.state.ESignModule.esignTemplateStatuses;

			if (this.documentRequest.id == null) {
				return undefined;
			}

			return statusMap.get(this.documentRequest.id);
		},
		showDescription(): boolean {
			return !!this.documentRequest.request.documentDescription;
		},
		isOPNDocumentDetectionEnabled(): boolean {
			return this.directStore.state.FeatureFlag.activeFeatures?.has(FeatureFlagging.FeatureFlagEnum.EnableOpnDocumentDetection) ?? false;
		},
		showMarkOnFileModal(): boolean {
			return this.isOPNDocumentDetectionEnabled && this.potentialMatchCount > 0;
		}
	},
	async beforeMount() {
		await this.directStore.dispatch.ESignModule.fetchSignatureType({ applicationType: this.loanApplication?.type });
		await this.directStore.dispatch.ESignModule.fetchTemplateStatus({
			documentRequestId: this.documentRequest.id,
			documentNamesId: this.documentRequest.documentNamesId
		});
	},
	methods: {
		async openMarkOnFileModal(): Promise<void> {
			// Open the modal - the modal will handle loading potential matches
			const modalId = `mark-on-file-modal-${this.documentRequest.id}`;
			this.$bvModal.show(modalId);
		},
		onModalHidden(): void {
		},
		onMarkOnFileConfirmed(data: { documentRequestId: number; selectedDocument: Document }): void {
			// Emit event to parent component to handle marking the document on file
			this.$emit('mark-on-file-confirmed', data);

			// Close the modal
			const modalId = `mark-on-file-modal-${this.documentRequest.id}`;
			this.$bvModal.hide(modalId);
		}
	}
});
